import { useContext } from 'react';
import { ActingRoleContext } from '../contexts/ActingRoleContext';

const useActingRole = () => {
    const context = useContext(ActingRoleContext);

    if (!context) {
        throw new Error('useActingRole must be used inside ActingRoleProvider');
    }

    return context;
};

export default useActingRole;
